import { useQuery } from '@redwoodjs/web';

import { GET_MERCHANT_DASHBOARD_NOTES } from 'src/graphql/queries/merchants.query';

const useMerchantDashboardNotes = (merchantId: number) => {
    const { data, loading, error, refetch } = useQuery(GET_MERCHANT_DASHBOARD_NOTES, {
        fetchPolicy: 'network-only',
        variables: { id: merchantId },
        skip: !merchantId,
    });

    return {
        data,
        loading,
        error,
        refetchNotes: refetch,
    };
};

export default useMerchantDashboardNotes;
